import React from 'react';
import { IExtra } from '../../../../domain/ancillary/domain/models/IExtra';
import { IExtraLevel } from '../nested-input';
import { OptionGroup } from '../option';
import { adaptExtraToOptionGroup } from './adapters/adaptExtraToOptionGroup';

interface IExtraProps {
	extra: IExtra;
	nestedInputLevel: IExtraLevel;
}

export const Extra = ({ extra, nestedInputLevel }: IExtraProps) => {
	const optionGroup = adaptExtraToOptionGroup(extra, nestedInputLevel);

	return <OptionGroup optionGroup={optionGroup} />;
};
